import React from 'react'
import { useDispatch } from 'react-redux'
import { PropTypes } from 'prop-types'
import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Typography,
} from '../../../../components/mui/Core/index'
import { ContentCopyIcon } from '../../../../components/mui/Icons/index'
import GenericSnackbar from '../../../../components/GenericSnackbar/generic-snackbar'
import { setSnackbar } from '../../../../components/GenericSnackbar/generic-snackbar-slice'
import * as Constants from '../../../../constants/en.json'

function BillingDetailsCard({ orderDetails }) {
  const dispatch = useDispatch()
  const billName = orderDetails?.billToName
  const billCustomerNumber = orderDetails?.billToCustNum
  const billToPhone = orderDetails?.billToPhone

  const headerStyle = { py: 3 }
  const bodyStyle = { py: 2 }
  const smallTopMargin = { mt: 1.5 }
  const mediumTopMargin = { mt: 2 }

  const handleCopyCustomerPhone = (phoneNum) => {
    navigator.clipboard
      .writeText(phoneNum)
      .then(() => {
        dispatch(
          setSnackbar({
            message: 'Contact Phone copied to clipboard',
            severity: 'success',
            action: true,
          }),
        )
      })
      .catch(() => {
        // Nothing to do
      })
  }

  return (
    <>
      <Card variant='outlined' sx={{ height: '100%', width: '100%' }}>
        <CardContent sx={headerStyle}>
          <Typography variant='h6'>{Constants.orders.order_details.BILLING_DETAILS}</Typography>
        </CardContent>
        <Divider />
        <CardContent sx={bodyStyle}>
          <Box>
            <Grid container spacing={2}>
              <Grid size={{ xs: 6 }} sx={smallTopMargin}>
                <Typography variant='h6'>{Constants.orders.order_details.BILL_TO_NAME}</Typography>
                {billCustomerNumber && (
                  <>
                    <Typography variant='body1'>{billName}</Typography>
                    <Typography variant='body1'>{billCustomerNumber}</Typography>
                  </>
                )}
              </Grid>

              <Grid size={{ xs: 6 }} sx={smallTopMargin}>
                <Typography variant='h6'>
                  {Constants.orders.order_details.CONTACT_PHONE}
                  {billToPhone && (
                    <ContentCopyIcon
                      fontSize='sm'
                      sx={{ ml: 2, cursor: 'pointer' }}
                      onClick={() => {
                        handleCopyCustomerPhone(billToPhone)
                      }}
                    />
                  )}
                </Typography>
                <Typography variant='body1' sx={{ wordBreak: 'break-word' }}>
                  {billToPhone || Constants.orderAllocations.NONE}
                </Typography>
              </Grid>
            </Grid>

            <Grid container spacing={2} sx={mediumTopMargin}>
              <Grid size={{ xs: 6 }}>
                <Typography variant='h6' sx={{ mt: 3 }}>
                  {Constants.orders.order_details.BILL_TO_ADDRESS}
                </Typography>
                {orderDetails?.billToAddr1 && (
                  <Typography variant='body1'>{orderDetails.billToAddr1}</Typography>
                )}
                {orderDetails?.billToAddr2 && (
                  <Typography variant='body1'>{orderDetails.billToAddr2}</Typography>
                )}
                {orderDetails?.billToAddr3 && (
                  <Typography variant='body1'>{orderDetails.billToAddr3}</Typography>
                )}
                <Typography variant='body1'>
                  {orderDetails?.billToCity}, {orderDetails?.billToState}{' '}
                  {orderDetails?.billToCountry} {orderDetails?.billToZip}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Card>
      <GenericSnackbar />
    </>
  )
}

BillingDetailsCard.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  orderDetails: PropTypes.any.isRequired,
}

export default BillingDetailsCard
